import { defineComponent as _defineComponent } from 'vue'
interface IProps {
  outline?: boolean;
  white?: boolean;
  disabled?: boolean;
  small?: boolean;
  type?: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AppButton',
  props: {
    outline: { type: Boolean, default: false },
    white: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    small: { type: Boolean },
    type: { default: "" }
  },
  emits: ["on-click"],
  setup(__props: any, { expose, emit }) {
  expose();

const props = __props as { outline: boolean, white: boolean, disabled: boolean, small?: boolean, type: string }




const clickHandler = (): void => {
  if (!props.disabled) {
    emit("on-click");
  }
};

const __returned__ = { props, emit, clickHandler }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})